import Swal from "sweetalert2/dist/sweetalert2";
import { i18n } from "@/i18n";
import { htmlSanitizer } from "@/services/utilities/html-sanitizer";

class NotificationManager {
  alert = null;
  toast = null;
  constructor() {}

  showNotification(type, title, timer = 4000, position = "top-end", showButton = false, customClass = "") {
    this.toast = Swal.mixin({
      toast: true,
      position: position,
      showConfirmButton: showButton,
      timer: timer,
      customClass: {
        popup: customClass,
      },
    });
    // Security-review finding (ST143-TI-17771, MUST FIX): SweetAlert2 renders `title` through its own
    // innerHTML parser regardless of the `html`/`text` option used elsewhere — it was left out of the
    // §2.7 sanitization pass, which only covered `subTitle`. Several callers pass backend-supplied strings
    // here (e.g. notepad-manager.js's `data.message`).
    return this.toast.fire({
      icon: type,
      title: htmlSanitizer.sanitize(title),
    });
  }

  showAlert(
    type,
    title,
    subTitle = "",
    closeButton = false,
    cancelButton = false,
    confirmButtonText = null,
    cancelButtonText = null,
    color = "#000",
    containerClass = "",
    html = false,
    allowOutsideClick = true,
    extraOptions = {},
  ) {
    // ST143-TI-17771 (§2.7): SweetAlert2's `html` option renders `subTitle` as raw HTML — sanitize it here,
    // once, rather than at each of the 5 call sites, so every current and future caller is covered.
    // Security-review finding (MUST FIX): `title` is ALSO rendered through SweetAlert2's own innerHTML
    // parser regardless of the `html` option (verified against sweetalert2's parseHtmlToContainer()) — the
    // original pass only sanitized subTitle. confirmButtonText/cancelButtonText are the same kind of sink;
    // sanitized too since it costs nothing and both can be caller-supplied.
    // `...extraOptions` is spread FIRST so none of the sanitized keys below can be silently overridden by a
    // caller-supplied unsanitized value with the same key.
    this.alert = new Swal({
      ...extraOptions,
      icon: type,
      title: htmlSanitizer.sanitize(title),
      text: html ? null : subTitle,
      html: html ? htmlSanitizer.sanitize(subTitle) : null,
      padding: "2em",
      showCloseButton: closeButton,
      showCancelButton: cancelButton,
      cancelButtonText: htmlSanitizer.sanitize(cancelButtonText ? cancelButtonText : i18n.global.t("cancel")),
      confirmButtonText: htmlSanitizer.sanitize(confirmButtonText ? confirmButtonText : i18n.global.t("confirm")),
      color: color,
      customClass: {
        container: containerClass,
      },
      allowOutsideClick: allowOutsideClick,
    });

    const container = document.querySelector(".swal2-container");
    container.addEventListener("click", function (e) {
      e.stopPropagation();
    });

    return this.alert;
  }

  closeAlert() {
    if (this.alert) {
      this.alert.close();
      this.alert = null;
    }
  }
}

export const notificationManager = new NotificationManager();
